var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useMemo, useEffect, useContext, useRef } from "react";
import dayjs from "dayjs";
import axios from "axios";
import APIMap from "../api_map.js";
import jwt from "jwt-decode";
import { roleName, tableDetails } from "../constants_map.js";
import { createScopePermissions } from "../assets/constants/scope";
import getIP from "../getIP.js";
import { useTranslation } from "react-i18next";
import { ConfigMap } from "utils/configMap.js";
import { imageUrlToBase64 } from "utils/FileHelpers.js";
let isRefreshing = false;
let refreshSubscribers = []; // array of promises
const refreshTokenAttempt = new Map();
function onRefreshTokenFetched(newToken) {
    // resolve pending promises and proceed api
    console.log("refreshSubscribers resolved", refreshSubscribers.length);
    refreshSubscribers.forEach(([resolve]) => resolve(newToken));
    // reset queue
    isRefreshing = false;
    refreshSubscribers = [];
}
function onRefreshTokenFail() {
    // resolve pending promises and proceed api
    // eslint-disable-next-line no-unused-vars
    refreshSubscribers.forEach(([resolve, reject]) => reject());
    // reset queue
    isRefreshing = false;
    refreshSubscribers = [];
}
function addRefreshSubscriber(resolve, reject) {
    console.log("refreshSubscribers rejected", refreshSubscribers.length);
    refreshSubscribers.push([resolve, reject]);
}
export const AuthContext = React.createContext();
/**
 * Mapping of user roles to short codes.
 * @type {Object<string, string>}
 */
const loggedInRoleMap = {
    [roleName.enterpriseAdmin]: "EA",
    [roleName.enterpriseUser]: "EU",
    [roleName.platformAdmin]: "PA",
    [roleName.globalUser]: "PA",
    [roleName.enterpriseSuperUser]: "ESU",
    [roleName.Finance]: "PFA",
    [roleName.Marketing]: "PMA",
};
/**
 * Mapping of user related Map
 * @type {Object<string, string>}
 */
const userRelatedMap = {
    [roleName.enterpriseAdmin]: true,
    [roleName.enterpriseUser]: true,
    [roleName.enterpriseSuperUser]: true,
};
/**
 * Mapping of pa related Map
 * @type {Object<string, string>}
 */
const paRelatedMap = {
    [roleName.platformAdmin]: true,
    [roleName.Finance]: true,
    [roleName.Marketing]: true,
    [roleName.globalUser]: true,
};
export const determineUserRole = (userRole) => {
    const role = userRole === roleName.enterpriseAdmin
        ? "EA"
        : userRole === roleName.enterpriseUser
            ? "EU"
            : userRole === roleName.platformAdmin || userRole === roleName.globalUser
                ? "PA"
                : userRole === roleName.Marketing
                    ? "PMA"
                    : userRole === roleName.Finance
                        ? "PFA"
                        : "NA";
    return role;
};
export const AuthProvider = ({ children }) => {
    const IP = getIP();
    const SECRETPASS = process.env.REACT_APP_SECRETPASS;
    const [accountsEditData, setAccountsEditData] = useState();
    const [packagesEditData, setPackagesEditData] = useState();
    const [rateSheetEditData, setRateSheetEditData] = useState();
    const [peIdDetails, setPeIdDetails] = useState({});
    const { t, i18n } = useTranslation();
    const [state, setState] = useState({
        isLoaded: false,
        open: false,
        terms: "",
        loading: false,
        mobile: "",
        email2: "",
    });
    const [userDetails, setUserDetails] = useState(JSON.parse(localStorage.getItem("userDetails")) || null);
    const [userRole, setUserRole] = useState("");
    const [enableVoice, setEnableVoice] = useState(false);
    const [providerTab, setProviderTab] = useState("SMS");
    const [routingTab, setRoutingTab] = useState("SMS");
    const [smsTemplates] = useState([]);
    const [emailTemplates] = useState([]);
    const [showSessionExpiredModal, setShowSessionExpiredModal] = useState(false);
    const [user, setUser] = useState(JSON.parse(sessionStorage.getItem("user")) || null);
    const [isAppTimeout, setAppTimeout] = useState(false);
    const appTimeout = useRef(null);
    const [email, setEmail] = useState("");
    const [audio, setAudio] = useState(new Audio());
    const [userEmail, setUserEmail] = useState(null);
    const [otp] = useState(0);
    const [smsTemplateDetails, setSmsTemplateDetails] = useState({});
    const [EmailTemplateDetails, setEmailTemplateDetails] = useState({});
    const [ContactDetails, setContactDetails] = useState({});
    const [ContactGroupDetails, setContactGroupDetails] = useState({});
    const [roleTemplates, setTemplates] = useState([]);
    const [distributionListDetails, setdistributionListDetails] = useState({});
    const [filesummary, setfilesummary] = useState({});
    const [resourceData, setResourceData] = useState([]);
    const [singleUserDetails, setSingleUserDetails] = useState({});
    const [editRoleData, setEditRoleData] = useState("");
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem("userData")) || {
        email: "",
        name: "",
        contactNo: "",
    });
    const [packages, setPackages] = useState([]);
    const [userGroups, setUserGroups] = useState(JSON.parse(localStorage.getItem("userGroups")) || []);
    const [rateSheets, setRateSheets] = useState([]);
    const [rateSheetDetails, setRateSheetDetails] = useState([]);
    const [numberData, setNumberData] = useState({});
    const [selWaTemplateData, setSelWaTemplateData] = useState([]);
    const [tab, setTab] = useState("SMS");
    const [userScope, setUserScope] = useState({});
    const [vrDetails, setVrDetails] = useState([]);
    const [allCountries, setAllCountries] = useState([]);
    const [collapsed, setCollapsed] = useState(false);
    const [globalConfig, setGlobalConfig] = useState([]);
    const [Time, setResendTime] = useState(0);
    const [allowedChannels, setAllowedChannels] = useState([]);
    const [currencyCode, setCurrencyCode] = useState("");
    const [currencySymbol, setCurrencySymbol] = useState("");
    const exceptionEndpoints = [];
    axios.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
        const isException = exceptionEndpoints.some((endpoint) => config.url.includes(endpoint));
        // If token refresh is in progress, wait for it to complete
        if (isRefreshing && config.url !== IP + APIMap("refreshToken")) {
            const newAccessToken = yield new Promise((resolve, reject) => {
                addRefreshSubscriber(resolve, reject);
            });
            axios.defaults.headers.Authorization = `Bearer ${newAccessToken}`;
            config.headers["Authorization"] = `Bearer ${newAccessToken}`;
        }
        const epochTime = Date.now();
        if (!isException) {
            config.headers["Accept-Language"] = i18n.language;
            config.headers["Unix-Timestamp-Nonce"] = epochTime;
        }
        return config;
    }), (error) => {
        return Promise.reject(error);
    });
    const channels = {
        sms: "SMS",
        wa: "WhatsApp",
        voice: "Voice",
        vr: "Virtual Receptionist",
        email: "Email",
        rcs: "RCS",
        chatbot: "Chatbot",
        network: "Network",
        studio: "Studio",
    };
    const token = userDetails === null || userDetails === void 0 ? void 0 : userDetails.token;
    const getAllCountries = () => {
        try {
            var url = IP + APIMap("getCountries") + "?paging=0";
            axios.get(url).then((res) => {
                var _a;
                setAllCountries(((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) || []);
            });
        }
        catch (err) {
            console.log("countriy fetch err", err);
        }
    };
    useEffect(() => {
        getAllCountries();
        const user = sessionStorage.getItem("user");
        if (user && user != "null") {
            setUser(JSON.parse(user));
        }
        const userDetails = localStorage.getItem("userDetails");
        if (userDetails) {
            setUserDetails(JSON.parse(userDetails));
        }
        const userData = localStorage.getItem("userData");
        if (userData) {
            setUserData(JSON.parse(userData));
        }
        const userGroups = localStorage.getItem("userGroups");
        if (userGroups) {
            setUserGroups(JSON.parse(userGroups));
        }
    }, []);
    // useEffect(() => {
    //   const handleBeforeUnload = async (event) => {
    //     event.preventDefault();
    //     const revokeUrl = IP + APIMap("revoke");
    //     console.log("making api call before tab is closed...");
    //     try {
    //       const config = {
    //         headers: {
    //           Authorization: `Bearer ${user?.data?.access_token}`,
    //         },
    //       };
    //       const revRes = await axios.post(
    //         revokeUrl,
    //         {
    //           token: user?.data?.refresh_token,
    //           accessToken: user?.data?.access_token,
    //         },
    //         config
    //       );
    //       console.log("API call before closing tab succeeded");
    //     } catch (error) {
    //       console.error("API call failed before closing tab:", error);
    //     }
    //     // const confirmationMessage = "\o/";
    //     // (event || window.event).returnValue = confirmationMessage;
    //     // return confirmationMessage;
    //   };
    //   window.addEventListener("beforeunload", handleBeforeUnload);
    //   return () => {
    //     window.removeEventListener("beforeunload", handleBeforeUnload);
    //   };
    // }, []);
    const getGlobalConfig = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var url = IP + APIMap("getConfig") + "?scope=gui";
        try {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            let res = yield axios.get(url, config);
            if (Array.isArray((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data)) {
                const configData = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data;
                setGlobalConfig(configData);
                const zoomValue = ((_c = configData === null || configData === void 0 ? void 0 : configData.find((config) => (config === null || config === void 0 ? void 0 : config.key) === "guiZoomPercentage")) === null || _c === void 0 ? void 0 : _c.value) || "100";
                document.documentElement.style.setProperty("--zoom", zoomValue + "%");
            }
            else {
                console.log("global config error", res);
            }
            let allowedChannels = ["All Channels"];
            let dynamicChannels = (_e = (_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.find((e) => e.key === "allowedChannels").value.trim().split(",").map((e) => e.trim()).map((e) => channels[e]);
            allowedChannels = [...allowedChannels, ...dynamicChannels];
            const currencyCode = (_h = (_g = (_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.find((e) => e.key === "currencyCode")) === null || _h === void 0 ? void 0 : _h.value;
            const currencySymbol = (_l = (_k = (_j = res === null || res === void 0 ? void 0 : res.data) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.find((e) => e.key === "currencySymbol")) === null || _l === void 0 ? void 0 : _l.value;
            if (allowedChannels.includes("Email")) {
                console.log("loading bee free script because email channel is enabled");
                // NOSONAR: Script is approved thirdparty and needs to be used
                const script = document.createElement("script");
                script.src = "https://app-rsrc.getbee.io/plugin/BeePlugin.js";
                script.type = "text/javascript";
                script.async = true;
                script.defer = true;
                document.head.appendChild(script);
            }
            setAllowedChannels(allowedChannels);
            setCurrencyCode(currencyCode);
            setCurrencySymbol(currencySymbol);
        }
        catch (error) {
            setAllowedChannels(["All Channels", "SMS"]);
            console.log("Error while fetching global config");
        }
    });
    useEffect(() => {
        if (user) {
            sessionStorage.setItem("user", JSON.stringify(user));
        }
        if (userDetails) {
            localStorage.setItem("userDetails", JSON.stringify(userDetails));
        }
        if ((userData === null || userData === void 0 ? void 0 : userData.email) || (userData === null || userData === void 0 ? void 0 : userData.contactNo)) {
            localStorage.setItem("userData", JSON.stringify(userData));
        }
        if (userDetails && userDetails.scope) {
            let data = createScopePermissions(userDetails.scope);
            setUserScope((userScope) => (Object.assign(Object.assign({}, userScope), data)));
            let role = userDetails.realm_access.roles[0].split("~");
            if (role.length > 1) {
                setUserRole(role[2]);
            }
            else {
                setUserRole(role[0]);
            }
            getGlobalConfig();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, userDetails, userData]);
    const clearStorage = (timeout, accessTok) => {
        let language = localStorage.getItem("i18nextLng");
        localStorage.clear();
        if (timeout) {
            // for timeout dialog
            if (accessTok) {
                try {
                    const jwtData = jwt(accessTok);
                    // current Time
                    const currentTime = Math.floor(Date.now() / 1000);
                    setAppTimeout(currentTime < jwtData.exp ? "remote_logout" : "expire");
                    appTimeout.current = true;
                }
                catch (err) {
                    setAppTimeout("expire");
                    appTimeout.current = true;
                }
            }
            else if (!appTimeout.current) {
                appTimeout.current = true;
                setAppTimeout("expire");
            }
        }
        else {
            setUser(null);
            appTimeout.current = false;
            setAppTimeout(false);
        }
        setUserEmail(null);
        setUserDetails(null);
        setUserData({
            email: "",
            name: "",
            contactNo: "",
        });
        sessionStorage.clear();
        localStorage.setItem("i18nextLng", language);
        localStorage.setItem("logout", dayjs());
    };
    const logout = (status, revokeAll) => __awaiter(void 0, void 0, void 0, function* () {
        const accessTok = sessionStorage.getItem("access");
        const refreshTok = sessionStorage.getItem("refresh");
        const revokeUrl = IP + APIMap("revoke");
        // after logout, disable refresh token processing
        onRefreshTokenFail();
        try {
            let revRes = null;
            if (!status) {
                // manual logout trigger
                try {
                    const config = {
                        headers: {
                            Authorization: `Bearer ${accessTok}`,
                        },
                    };
                    revRes = yield axios.post(revokeUrl, {
                        token: refreshTok,
                        accessToken: sessionStorage.getItem("access"),
                    }, config);
                }
                catch (err) {
                    console.log("error while calling access token revoke endpoint: ", err);
                }
            }
            // if (revRes?.status === 200 || status) {
            clearStorage(status, accessTok);
            // }
        }
        catch (err) {
            console.error("error while logging out: ", err);
        }
    });
    axios.interceptors.response.use(function (response) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (refreshTokenAttempt.has((_a = response === null || response === void 0 ? void 0 : response.config) === null || _a === void 0 ? void 0 : _a.url)) {
                //api success, so reset refresh token attempt
                refreshTokenAttempt.delete((_b = response === null || response === void 0 ? void 0 : response.config) === null || _b === void 0 ? void 0 : _b.url);
            }
            return response;
        });
    }, function (error) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            // Do something with response error
            if (!(error === null || error === void 0 ? void 0 : error.config)) {
                // api failed with no response config, so drop refresh token here
                onRefreshTokenFail();
            }
            //  if refresh token response is 401 then logout
            if (((_a = error === null || error === void 0 ? void 0 : error.config) === null || _a === void 0 ? void 0 : _a.url) === IP + APIMap("refreshToken") &&
                ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status) === 401) {
                onRefreshTokenFail();
                yield logout(true);
                return error;
            }
            const prevRequest = error === null || error === void 0 ? void 0 : error.config;
            // if access token expired fetch new access token
            if (((_c = error === null || error === void 0 ? void 0 : error.config) === null || _c === void 0 ? void 0 : _c.url) !== IP + APIMap("Cpassloginform") &&
                ((_d = error === null || error === void 0 ? void 0 : error.config) === null || _d === void 0 ? void 0 : _d.url) !== IP + APIMap("loginMfa") &&
                ((_e = error === null || error === void 0 ? void 0 : error.config) === null || _e === void 0 ? void 0 : _e.url) !== IP + APIMap("Cpassloginform1") &&
                ((_f = error === null || error === void 0 ? void 0 : error.response) === null || _f === void 0 ? void 0 : _f.status) === 401 &&
                !(prevRequest === null || prevRequest === void 0 ? void 0 : prevRequest.sent) &&
                !(((_h = (_g = error === null || error === void 0 ? void 0 : error.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.httpCode) === 401) // Invalid api Key for WA Sandbox
            ) {
                // below code was old refresh token handling
                // prevRequest.sent = true;
                // refreshing_token = refreshing_token
                //   ? refreshing_token
                //   : refreshTokens();
                // const result = await refreshing_token;
                // // for calling refresh token api only once
                // refreshing_token = null;
                // ----- max refresh attempt coun start-----
                const reshTokenAttemptCount = (refreshTokenAttempt.get((_j = error === null || error === void 0 ? void 0 : error.config) === null || _j === void 0 ? void 0 : _j.url) || 0) + 1;
                // set refresh token retry attempt count based on url
                refreshTokenAttempt.set((_k = error === null || error === void 0 ? void 0 : error.config) === null || _k === void 0 ? void 0 : _k.url, reshTokenAttemptCount);
                console.log("refreshtokenAttempt", (_l = error === null || error === void 0 ? void 0 : error.config) === null || _l === void 0 ? void 0 : _l.url, reshTokenAttemptCount);
                if (reshTokenAttemptCount > 4) {
                    onRefreshTokenFetched(sessionStorage.getItem("refresh")); // allow other blocking api due to refresh token fetching
                    //wait for some time
                    yield new Promise((resolve) => setTimeout(resolve, 5000)); //when allowing other api block this particular error api
                    refreshTokenAttempt.delete((_m = error === null || error === void 0 ? void 0 : error.config) === null || _m === void 0 ? void 0 : _m.url); //allow gracefull way of reattempt
                    return {};
                }
                // ----- max refresh attempt coun end-----
                if (isRefreshing) {
                    // wait for new token
                    // console.log('refreshSubscribers start2', error.config.url);
                    const newAccessToken = yield new Promise((resolve, reject) => {
                        addRefreshSubscriber(resolve, reject);
                    });
                    // console.log('refreshSubscribers end2', error.config.url);
                    if ((error === null || error === void 0 ? void 0 : error.config) && newAccessToken) {
                        error.config.headers["Authorization"] = `Bearer ${newAccessToken}`;
                    }
                    // Retry the original request
                    return axios.request(prevRequest);
                }
                isRefreshing = true;
                const result = yield refreshTokens();
                prevRequest.headers["Authorization"] = `Bearer ${(_o = result === null || result === void 0 ? void 0 : result.data) === null || _o === void 0 ? void 0 : _o.access_token}`;
                return prevRequest;
            }
            return Promise.reject(error);
        });
    });
    const refreshTokens = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const refreshToken = sessionStorage.getItem("refresh");
            const access = sessionStorage.getItem("access");
            // if refresh token is empty no need to call refresh token api
            if (!refreshToken) {
                yield logout(true);
                onRefreshTokenFail();
                return;
            }
            const payload = {
                refresh_token: refreshToken,
                access_token: access,
            };
            const config = {
                headers: {
                    Authorization: `Bearer ${refreshToken}`,
                },
            };
            var url = IP + APIMap("refreshToken");
            let result = yield axios.post(url, payload, config);
            // assign new token to axios header
            axios.defaults.headers.Authorization = `Bearer ${sessionStorage.getItem("access")}`;
            // Retry the original request with the new token
            onRefreshTokenFetched(result.data.access_token); // pass all pending requests in req interceptor
            sessionStorage.setItem("refresh", result.data.refresh_token);
            sessionStorage.setItem("access", result.data.access_token);
            console.log("set to session storage");
            let accessToken = jwt(result.data.access_token);
            accessToken["token"] = result.data.access_token.trim();
            setUser({ data: result.data });
            setUserDetails(accessToken);
            setUserGroups(accessToken.groups);
            return result;
        }
        catch (error) {
            onRefreshTokenFail();
            yield logout(true);
            //console.log(error);
        }
    });
    const value = useMemo(() => {
        var _a, _b, _c;
        const signup = (param) => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            localStorage.removeItem("count");
            localStorage.removeItem("count3");
            localStorage.removeItem("count1");
            localStorage.removeItem("COUNTER_KEY1");
            localStorage.removeItem("COUNTER_KEY");
            localStorage.removeItem("COUNTER_KEY3");
            setEmail(param.email);
            localStorage.setItem("email", param.email);
            setState(Object.assign(Object.assign({}, state), { loading: true }));
            var url = IP + APIMap("signup");
            localStorage.setItem("timerOn", true);
            localStorage.setItem("countryCode", (_a = param === null || param === void 0 ? void 0 : param.countryCode) === null || _a === void 0 ? void 0 : _a.value);
            localStorage.setItem("mobileNumber", param.mobileNumber);
            const result = yield axios.post(url, {
                name: param.name,
                email: param.email,
                company: param.company,
                countryCode: (_b = param.countryCode) === null || _b === void 0 ? void 0 : _b.value,
                mobile: param.mobileNumber,
            });
            return result;
        });
        const EmailNotification = (email, countryCode, mobile, deployURL) => {
            if (!countryCode)
                countryCode = localStorage.getItem("countryCode");
            if (!mobile)
                mobile = localStorage.getItem("mobileNumber");
            localStorage.setItem("timerOn", true);
            localStorage.setItem("email", email);
            if (localStorage.getItem("count") == null) {
                localStorage.setItem("count", 1);
            }
            else {
                localStorage.setItem("count", parseInt(localStorage.getItem("count")) + 1);
            }
            var url = IP + APIMap("activationlink");
            const targetarr = [];
            targetarr.push(email);
            return axios.post(url, Object.assign(Object.assign({ targets: [email], msgTemplate: "setPasswordEmail" }, (deployURL && { deploymentURL: deployURL })), (countryCode && mobile
                ? {
                    templateValues: {
                        COUNTRY_CODE: countryCode,
                        MOBILE: mobile,
                    },
                }
                : undefined)));
        };
        const encryptText = (text) => {
            // const encryptedText = CryptoJS.AES.encrypt(
            //   JSON.stringify(text),
            //   SECRETPASS
            // ).toString();
            // return encryptedText || "";
            return text;
        };
        const setPassword = (param) => {
            var url = IP + APIMap("setpassword");
            localStorage.setItem("userid", param.userid);
            return axios.post(url, {
                token: param.usertoken,
                password: encryptText(param.password),
            });
        };
        const handleClose = () => {
            setState(Object.assign(Object.assign({}, state), { open: false }));
        };
        const setMobileNumber = (param) => __awaiter(void 0, void 0, void 0, function* () {
            localStorage.setItem("mobileNumber", param.mobileNumber);
            localStorage.setItem("countryCode", param.countryCode.value);
            localStorage.setItem("timerOn1", true);
            localStorage.setItem("otpCounter", 1);
            if (localStorage.getItem("count1") == null) {
                localStorage.setItem("count1", 1);
            }
            else {
                localStorage.setItem("count1", parseInt(localStorage.getItem("count1")) + 1);
            }
            var url = IP + APIMap("sendotp");
            let jsonObject = {};
            if (localStorage.getItem("userid")) {
                if (localStorage.getItem("email")) {
                    jsonObject.targets = [localStorage.getItem("email")];
                }
                else {
                    jsonObject.targets = [""];
                }
                jsonObject.uid = localStorage.getItem("userid");
                jsonObject.ttl = "5";
            }
            else {
                jsonObject.targets = [localStorage.getItem("email")];
                jsonObject.ttl = "5";
            }
            return yield axios.post(url, jsonObject);
        });
        const getTerms = () => __awaiter(void 0, void 0, void 0, function* () {
            var url = IP + APIMap("systemDocs");
            url = url.replace("{filename}", "terms_and_conditions.html");
            const result = yield axios.get(url);
            return result;
        });
        const getScreenElement = () => {
            var url = IP + APIMap("screenelement");
            return axios.get(url);
        };
        const addSmsTemplate = (obj) => __awaiter(void 0, void 0, void 0, function* () {
            let TemplateMsgs = [];
            TemplateMsgs.push({ language: "en", msg: obj.message });
            const obj1 = {
                name: obj.name,
                type: obj.type,
                category: obj.category,
                defaultLanguage: "en",
                messages: TemplateMsgs,
            };
            const config = {
                headers: {
                    Authorization: `Bearer ${userDetails === null || userDetails === void 0 ? void 0 : userDetails.token}`,
                },
            };
            var url = IP + APIMap("addTemplate");
            let response = yield axios.post(url, obj1, config);
            return response;
        });
        const getSmsTemplates = (type, pageParam, status, category) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: `Bearer ${userDetails === null || userDetails === void 0 ? void 0 : userDetails.token}`,
                },
            };
            let statusString = `${status || status === "0" || status === 0 ? `&status=${status}` : ""}`;
            let categoryString = `${category || category === "0" || category === 0
                ? `&category=${category}`
                : ""}`;
            let url = "";
            url = IP + APIMap("getTemplates");
            url =
                url +
                    `?type=${type}&pgsize=3&pgindex=${pageParam}${statusString}${categoryString}`;
            let response = yield axios.get(url, config);
            return response;
        });
        const deleteSmsTemplate = (templateId) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: `Bearer ${userDetails === null || userDetails === void 0 ? void 0 : userDetails.token}`,
                },
            };
            let url = IP + APIMap("deleteTemplate");
            url = url.replace("{id}", templateId);
            let response = yield axios.delete(url, config);
            return response;
        });
        const addEmailTemplate = (obj) => __awaiter(void 0, void 0, void 0, function* () {
            var response;
            var config = {};
            var url = "";
            if (obj.type === "s" || obj.type === "p") {
                var obj1 = {
                    name: obj.name,
                    type: obj.type,
                    message: obj.message,
                };
                config = {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                };
                url = IP + APIMap("addTemplateEmail");
                response = yield axios.post(url, obj1, config);
            }
            else if (obj.type == "u") {
                let payload = new FormData();
                payload.append("name", obj.name);
                payload.append("type", obj.type);
                payload.append("file", obj.file);
                payload.append("html", obj.html);
                config = {
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "multipart/form-data",
                    },
                };
                url = IP + APIMap("uploadTemplateEmail");
                console.log("Posting ----", url);
                console.log("Config in Auth ", config);
                for (let [key, val] of payload.entries()) {
                    console.log(key, val);
                }
                let response = yield axios.post(url, payload, config);
                console.log("Response is ", response);
            }
            else if (obj.type == "r") {
                let payload = new FormData();
                payload.append("name", obj.name);
                payload.append("type", obj.type);
                payload.append("html", obj.html);
                payload.append("json", JSON.stringify(obj.json));
                config = {
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "multipart/form-data",
                    },
                };
                url = IP + APIMap("uploadContentEmail");
                console.log("Posting ----", url);
                console.log("Config in Auth ", config);
                for (let [key, val] of payload.entries()) {
                    console.log(key, val);
                }
                let response = yield axios.post(url, payload, config);
                console.log("Response is ", response);
            }
            return response;
        });
        const getEmailTemplates = (type, pageParam) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: `Bearer ${userDetails === null || userDetails === void 0 ? void 0 : userDetails.token}`,
                },
            };
            let url = "";
            url = IP + APIMap("getTemplatesEmail");
            url = url + `?type=${type}&pgsize=3&pgindex=${pageParam}`;
            let response = yield axios.get(url, config);
            return response;
        });
        const deleteEmailTemplate = (templateId) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: `Bearer ${userDetails === null || userDetails === void 0 ? void 0 : userDetails.token}`,
                },
            };
            let url = IP + APIMap("deleteTemplateEmail");
            url = url.replace("{id}", templateId);
            let response = yield axios.delete(url, config);
            return response;
        });
        const getPolicy = () => {
            var url = IP + APIMap("systemDocs");
            url = url.replace("{filename}", "privacy_policy.html");
            return axios.get(url);
        };
        const changePassword = (param) => {
            const config = {
                headers: {
                    Authorization: `Bearer ${param.token}`,
                },
            };
            var url = IP + APIMap("changePassword");
            //Encrypt passwords
            return axios.post(url, {
                oldPassword: encryptText(param.oldpassword),
                newPassword: encryptText(param.newpassword),
                token: sessionStorage.getItem("refresh"),
            }, config);
        };
        const getUser = (uid, token) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var url = IP + APIMap("getuserid");
            url = url.replace("{id}", uid);
            let resp = yield axios.get(url, config);
            // Fetch the image using Axios
            let profilebase64 = "";
            if ((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.profilepicture) {
                try {
                    const base64Image = yield imageUrlToBase64(resp.data.profilepicture, token);
                    profilebase64 = base64Image;
                }
                catch (err) {
                    console.log("error fetching profileImg: ", err);
                }
            }
            setUserData(Object.assign(Object.assign({}, userData), { email: resp.data.email, name: resp.data.name, contactNo: resp.data.contactNo, countryCode: resp.data.countryCode, profileImg: profilebase64, organisation: resp.data.organisation, createdby: resp.data.createdby }));
        });
        const closeSesionExpireModal = () => {
            setUser(null);
            appTimeout.current = false;
            setAppTimeout(false);
        };
        const loginCaptcha = (param) => __awaiter(void 0, void 0, void 0, function* () {
            localStorage.setItem("email", param.email);
            console.log("param for logincaptcha", param);
            var url = IP + APIMap("loginCaptcha");
            try {
                let response = yield axios.post(url, {
                    [param.usenameLogin === "true"
                        ? param.email.includes("@")
                            ? "email"
                            : "username"
                        : "email"]: param.email,
                    password: encryptText(param.pwd),
                    interface: "gui",
                    validationToken: param.validationToken,
                });
                axios.defaults.headers.Authorization = `Bearer ${response.data.access_token}`;
                sessionStorage.setItem("access", response.data.access_token);
                sessionStorage.setItem("refresh", response.data.refresh_token);
                setAppTimeout(false);
                setUser(response);
                let accessToken = jwt(response.data.access_token);
                accessToken["token"] = response.data.access_token.trim();
                getUser(accessToken.sub, accessToken.token);
                setUserGroups(accessToken.groups);
                localStorage.setItem("userGroups", JSON.stringify(accessToken.groups));
                setUserDetails(accessToken);
                return accessToken;
            }
            catch (err) {
                throw err;
            }
        });
        const login = (param) => __awaiter(void 0, void 0, void 0, function* () {
            localStorage.setItem("email", param.email);
            var url = IP +
                APIMap(param.usenameLogin === "true" ? "Cpassloginform1" : "Cpassloginform");
            // eslint-disable-next-line no-useless-catch
            try {
                let response = yield axios.post(url, {
                    [param.usenameLogin === "true"
                        ? param.email.includes("@")
                            ? "email"
                            : "username"
                        : "email"]: param.email,
                    password: encryptText(param.pwd),
                    interface: "gui",
                });
                axios.defaults.headers.Authorization = `Bearer ${response.data.access_token}`;
                sessionStorage.setItem("access", response.data.access_token);
                sessionStorage.setItem("refresh", response.data.refresh_token);
                appTimeout.current = false;
                setAppTimeout(false);
                setUser(response);
                let accessToken = jwt(response.data.access_token);
                accessToken["token"] = response.data.access_token.trim();
                getUser(accessToken.sub, accessToken.token);
                setUserGroups(accessToken.groups);
                localStorage.setItem("userGroups", JSON.stringify(accessToken.groups));
                setUserDetails(accessToken);
                return accessToken;
            }
            catch (err) {
                throw err;
            }
        });
        const updateUser = (_a) => __awaiter(void 0, [_a], void 0, function* ({ uid, values, token, profileImg }) {
            let formData = new FormData();
            formData.append("name", values.name);
            formData.append("contactNo", values.mobileNumber);
            formData.append("countryCode", values.countryCode.value);
            if (Object.prototype.hasOwnProperty.call(values, "vrUserSettings")) {
                formData.append("vrUserSettings", values.vrUserSettings);
            }
            if (profileImg !== null)
                formData.append("profileImg", profileImg);
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var url = IP + APIMap("updateuser");
            url = url.replace("{id}", uid);
            let response = yield axios.put(url, formData, config);
            const updatedUserData = Object.assign(Object.assign(Object.assign(Object.assign({}, userData), { name: values.name, contactNo: values.mobileNumber, countryCode: values.countryCode.value }), (Object.prototype.hasOwnProperty.call(values, "vrUserSettings") && {
                vrUserSettings: values.vrUserSettings,
            })), (profileImg && { profileImg: URL.createObjectURL(profileImg) }));
            localStorage.setItem("userData", JSON.stringify(updatedUserData));
            setUserData(updatedUserData);
            return response;
        });
        const setLoader = () => {
            setState(Object.assign(Object.assign({}, state), { loading: false }));
        };
        const getTemplateById = (id) => __awaiter(void 0, void 0, void 0, function* () {
            var url = IP + APIMap("getTemplate");
            url = url.replace("{id}", id);
            let response = yield axios.get(url);
            return response;
        });
        const editSmsTemplate = (obj) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: `Bearer ${userDetails === null || userDetails === void 0 ? void 0 : userDetails.token}`,
                },
            };
            let TemplateMsgs = [];
            TemplateMsgs.push({ language: "en", message: obj.message, msg: obj.msg });
            let url = IP + APIMap("editTemplate");
            url = url.replace("{id}", obj.id);
            let response = yield axios.put(url, {
                name: obj.name,
                type: obj.type,
                defaultLanguage: "en",
                category: obj.category,
                description: obj.description,
                messages: TemplateMsgs,
            }, config);
            return yield response;
        });
        const editEmailTemplate = (obj) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: `Bearer ${userDetails === null || userDetails === void 0 ? void 0 : userDetails.token}`,
                },
            };
            var response;
            if (obj.type == "s" || obj.type == "p") {
                let url = IP + APIMap("editTemplateEmail");
                url = url.replace("{id}", obj.id);
                response = yield axios.put(url, {
                    name: obj.name,
                    type: obj.type,
                    defaultLanguage: "en",
                    description: obj.description,
                    message: obj.message,
                }, config);
            }
            else if (obj.type == "u" || obj.type == "r") {
                let url = IP + APIMap("cloneTemplateEmail");
                console.log("With type as ", obj.type, " and id as ", obj.id);
                url = url.replace("{id}", obj.id);
                console.log("Final Posting URL is ", url);
                let payload = {
                    name: obj.name,
                    type: obj.type,
                    defaultLanguage: "en",
                    id: obj.id,
                    userId: obj.userId,
                    templateURL: obj.templateURL,
                    createdAt: obj.createdAt,
                };
                if (obj.type === "r") {
                    payload.templateURLJSON = obj.templateURLJSON;
                }
                response = yield axios.put(url, payload, config);
            }
            return response;
        });
        const editRichMediaEmailTemplate = (obj) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: `Bearer ${userDetails === null || userDetails === void 0 ? void 0 : userDetails.token}`,
                },
            };
            var response;
            let url = IP + APIMap("editTemplateContentEmail");
            url = url.replace("{id}", obj.id);
            response = yield axios.put(url, {
                name: obj.name,
                type: obj.type,
                defaultLanguage: "en",
                id: obj.id,
                userId: obj.userId,
                templateURL: obj.templateURL,
                createdAt: obj.createdAt,
                json: obj.json,
                html: obj.htmlContent,
            }, config);
            return yield response;
        });
        const forgotPassword = ({ email, countryCode, mobileNumber, activationLinkMode, }) => {
            const activtnLinkMode = activationLinkMode || "email";
            setState(Object.assign(Object.assign({}, state), { loading: true, email2: email }));
            localStorage.setItem("timerOn3", true);
            if (localStorage.getItem("count3") == null) {
                localStorage.setItem("count3", 1);
            }
            else {
                localStorage.setItem("count3", parseInt(localStorage.getItem("count3")) + 1);
            }
            localStorage.setItem("email2", email);
            localStorage.setItem("countryCode", countryCode);
            localStorage.setItem("mobileNumber", mobileNumber);
            var url = IP + APIMap("forgotpassword");
            const body = Object.assign(Object.assign(Object.assign({}, (activtnLinkMode === "email" && {
                email: localStorage.getItem("email2"),
            })), (activtnLinkMode === "sms" && {
                countryCode,
                mobileNumber,
            })), { ttl: "5" });
            return axios.post(url, body);
        };
        const Lang = () => {
            var url = IP + APIMap("systemDocs");
            url = url.replace("{filename}", "lang.json");
            return axios.get(url);
        };
        const Logo = () => {
            var url = IP + APIMap("assetsAccounts");
            url = url.replace("{groupname}", "default");
            url = url.replace("{filename}", "comviva-logo.svg");
            return axios.get(url);
        };
        const cpassLogo = () => {
            var url = IP + APIMap("assetsAccounts");
            url = url.replace("{groupname}", "default");
            url = url.replace("{filename}", "comviva-logo.svg");
            return axios.get(url);
        };
        const Copyright = () => {
            var url = IP + APIMap("systemDocs");
            url = url.replace("{filename}", "copyright.html");
            return axios.get(url);
        };
        const BackGroundImage = () => {
            var url = IP + APIMap("assetsAccounts");
            url = url.replace("{groupname}", "default");
            url = url.replace("{filename}", "comviva-background.jpg");
            return axios.get(url);
        };
        const resetPassword = (token, n, userid) => {
            setState(Object.assign(Object.assign({}, state), { loading: true }));
            var url = IP + APIMap("resetpassword");
            return axios.post(url, {
                token: token,
                password: n,
                reset: 1,
            });
        };
        const verifyOtp = (n) => {
            setState(Object.assign(Object.assign({}, state), { loading: true }));
            var url = IP + APIMap("verifyotp");
            let jsonObject = {};
            jsonObject.countryCode = localStorage.getItem("countryCode");
            jsonObject.contactNo = localStorage.getItem("mobileNumber");
            jsonObject.otp = n;
            if (localStorage.getItem("userid")) {
                jsonObject.issuedTo = localStorage.getItem("userid");
            }
            else {
                jsonObject.issuedTo = localStorage.getItem("email");
            }
            return axios.post(url, jsonObject);
        };
        const verifyEmail = () => {
            var url = IP + APIMap("emailverification");
            return axios.post(url, {
                email: localStorage.getItem("email"),
                message: "", // base64 encoded content
                template: "", // an email template existing in the system.
                templateValues: {}, // a json object containing keys and values for template placeholder.
                ttl: "2m", // A string consisting of a number and a unit of time. for ex: 48 hours -> 48h
                appInfo: {},
                apppCallback: "",
            });
        };
        //contact management
        const addcontact = (obj_1, ...args_1) => __awaiter(void 0, [obj_1, ...args_1], void 0, function* (obj, additionalValues = null) {
            var _a, _b, _c;
            var obj1 = {
                name: obj.name,
                phone: obj.mobileNumber,
                countryCode: obj.countryCode.value,
                email: obj.email,
                address: obj.address,
                groups: obj.groups,
            };
            if (additionalValues) {
                for (const val in additionalValues) {
                    // dropdown values
                    if (((_a = additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues[val]) === null || _a === void 0 ? void 0 : _a.label) &&
                        ((_b = additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues[val]) === null || _b === void 0 ? void 0 : _b.value)) {
                        obj1[val] = (_c = additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues[val]) === null || _c === void 0 ? void 0 : _c.value;
                    }
                    else {
                        obj1[val] = additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues[val];
                    }
                }
            }
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("addcontact");
            let response = yield axios.post(url, obj1, config);
            return response;
        });
        const addbulkcontact = (obj) => __awaiter(void 0, void 0, void 0, function* () {
            var obj1 = {
                jobId: obj.jobId,
            };
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("addbulkcontact");
            let response = yield axios.post(url, obj1, config);
            return response;
        });
        const FileUpload = (obj) => __awaiter(void 0, void 0, void 0, function* () {
            let formData = new FormData();
            formData.append("file", obj);
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                    "Content-Type": "multipart/form-data",
                },
            };
            var url = IP + APIMap("bulkfileupload");
            let response = yield axios.post(url, formData, config);
            return response;
        });
        const RateSheetFileUpload = (obj) => __awaiter(void 0, void 0, void 0, function* () {
            let formData = new FormData();
            formData.append("file", obj);
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                    "Content-Type": "multipart/form-data",
                },
            };
            var url = IP + APIMap("bulkfileupload");
            let response = yield axios.post(url, formData, config);
            return response;
        });
        const DLFileUpload = (obj) => __awaiter(void 0, void 0, void 0, function* () {
            var config = {};
            var response = {};
            var url = IP + APIMap("dlfileuplaod");
            if (obj.type === "file") {
                let formData = new FormData();
                formData.append("file", obj.file);
                config = {
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "multipart/form-data",
                    },
                };
                response = yield axios.post(url, formData, config);
            }
            else if (obj.type === "manual") {
                var obj1 = {
                    manualLines: obj.manualLines,
                    uploadFileToken: 0,
                };
                config = {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                };
                response = yield axios.post(url, obj1, config);
            }
            return response;
        });
        const DLFileUploadEmail = (obj) => __awaiter(void 0, void 0, void 0, function* () {
            var config = {};
            var response = {};
            var url = IP + APIMap("emaildlfileuplaod");
            if (obj.type === "file") {
                let formData = new FormData();
                formData.append("file", obj.file);
                config = {
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "multipart/form-data",
                    },
                };
                response = yield axios.post(url, formData, config);
            }
            else if (obj.type === "manual") {
                var obj1 = {
                    manualLines: obj.manualLines,
                    uploadFileToken: 0,
                };
                config = {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                };
                response = yield axios.post(url, obj1, config);
            }
            return response;
        });
        const editDLFileUpload = (obj, dl) => __awaiter(void 0, void 0, void 0, function* () {
            var config = {};
            var response = {};
            var url = IP + APIMap("editdlfileupload");
            url = url.replace("{id}", dl.jobId);
            if (obj.type === "file") {
                let formData = new FormData();
                formData.append("file", obj.file);
                config = {
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "multipart/form-data",
                    },
                };
                response = yield axios.put(url, formData, config);
            }
            else if (obj.type === "manual") {
                var obj1 = {
                    manualLines: obj.manualLines,
                    uploadFileToken: 0,
                };
                config = {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                };
                response = yield axios.put(url, obj1, config);
            }
            return response;
        });
        const editEmailDLFileUpload = (obj, dl) => __awaiter(void 0, void 0, void 0, function* () {
            var config = {};
            var response = {};
            var url = IP + APIMap("editEmailDLFileUpload");
            url = url.replace("{id}", dl.jobId);
            if (obj.type === "file") {
                let formData = new FormData();
                formData.append("file", obj.file);
                config = {
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "multipart/form-data",
                    },
                };
                response = yield axios.put(url, formData, config);
            }
            else if (obj.type === "manual") {
                var obj1 = {
                    manualLines: obj.manualLines,
                    uploadFileToken: 0,
                };
                config = {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                };
                response = yield axios.put(url, obj1, config);
            }
            return response;
        });
        const deletefile = (jobId, fileNames) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
                data: {
                    files: Object.keys(fileNames),
                    jobId: jobId,
                },
            };
            var url = IP + APIMap("removefileupload");
            try {
                let response = yield axios.delete(url, config);
                return response;
            }
            catch (err) {
                return Promise.reject(err);
            }
        });
        const getsummary = (obj) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP;
            if (obj.type === "Email") {
                url = url + APIMap("getsummary");
            }
            else {
                url = url + APIMap("getsummary");
            }
            url = url.replace("{id}", obj.jobId);
            let response = yield axios.get(url, config);
            return yield response;
        });
        const ContactList = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey, pageParam = 0 }) {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            const searchString = queryKey[1] || queryKey[1] === 0 || queryKey[1] === "0"
                ? `&name=${queryKey[1]}`
                : "";
            var baseUrl = IP + APIMap("contactlist");
            var url = baseUrl +
                `?pgindex=${pageParam}&pgsize=${tableDetails.pageSize}&contact=true${searchString}`;
            let response = yield axios.get(url, config);
            return { response, nextPage: pageParam + 1 };
        });
        const ContactListForExport = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            const searchString = queryKey[1] || queryKey[1] === 0 || queryKey[1] === "0"
                ? `&name=${queryKey[1]}`
                : "";
            var baseUrl = IP + APIMap("contactlist");
            var url = baseUrl + `?page=${1}&per_page=1000000&contact=true${searchString}`;
            let response = yield axios.get(url, config);
            return response;
        });
        const contactSearchApi = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey, pageParam = 1 }) {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("contactlist");
            url =
                url +
                    `?page=${pageParam}&per_page=${tableDetails.pageSize}&contact=true&name=${queryKey[1]}`;
            let response = yield axios.get(url, config);
            return { response, nextPage: pageParam + 1 };
        });
        const editContactList = (obj_1, ...args_1) => __awaiter(void 0, [obj_1, ...args_1], void 0, function* (obj, additionalValues = null) {
            var _a, _b, _c, _d, _e;
            var addmems = [];
            var delmems = [];
            let grpid = [];
            let objgrp = [];
            objgrp = (_a = obj === null || obj === void 0 ? void 0 : obj.groups) === null || _a === void 0 ? void 0 : _a.split(",");
            if (ContactDetails.groups !== null && ContactDetails.groups !== "")
                grpid = ((_b = ContactDetails === null || ContactDetails === void 0 ? void 0 : ContactDetails.groups) === null || _b === void 0 ? void 0 : _b.split(",")) || [];
            objgrp.forEach((e) => {
                if (grpid.includes(e) === false)
                    addmems.push(e);
            });
            grpid.forEach((e) => {
                if (objgrp.includes(e) === false)
                    delmems.push(e);
            });
            addmems = addmems.filter((e) => e !== "");
            delmems = delmems.filter((e) => e !== "");
            var obj1 = {
                name: obj.name,
                phone: obj.mobileNumber,
                email: obj.email,
                address: obj.address,
                add: addmems,
                countryCode: obj.countryCode.value,
                delete: delmems,
            };
            if (additionalValues) {
                for (const val in additionalValues) {
                    // dropdown values
                    if (((_c = additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues[val]) === null || _c === void 0 ? void 0 : _c.label) &&
                        ((_d = additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues[val]) === null || _d === void 0 ? void 0 : _d.value)) {
                        obj1[val] = (_e = additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues[val]) === null || _e === void 0 ? void 0 : _e.value;
                    }
                    else {
                        obj1[val] = additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues[val];
                    }
                }
            }
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("editcontact");
            url = url.replace("{id}", obj.id);
            let response = yield axios.put(url, obj1, config);
            return response;
        });
        const deleteContactList = (param) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("deletecontact");
            url = url.replace("{id}", param.queryKey[1]);
            let response = yield axios.delete(url, config);
            return response;
        });
        //contactgroup management
        const addcontactgrp = (obj) => __awaiter(void 0, void 0, void 0, function* () {
            var obj1 = {
                groupName: obj.name,
                ids: obj.id,
            };
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("addcontactgrp");
            let response = yield axios.post(url, obj1, config);
            return response;
        });
        const Listcontactgrp = () => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("contactgrouplist");
            let response = yield axios.get(url, config);
            return response;
        });
        const deletecontactgrp = (param) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("deletecontactgrp");
            url = url.replace("{groupname}", param.queryKey[1]);
            let response = yield axios.delete(url, config);
            return response;
        });
        const editcontactgrp = (obj) => __awaiter(void 0, void 0, void 0, function* () {
            var addmems = [];
            var delmems = [];
            let grpid = [];
            grpid = ContactGroupDetails.members.split(",");
            obj.id.forEach((e) => {
                if (grpid.includes(e) === false)
                    addmems.push(e);
            });
            grpid.forEach((e) => {
                if (obj.id.includes(e) === false)
                    delmems.push(e);
            });
            var obj1 = {
                addMems: addmems,
                delMems: delmems,
            };
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("updatecontactgrp");
            url = url.replace("{groupname}", obj.name);
            let response = yield axios.put(url, obj1, config);
            return response;
        });
        const getdistributionlists = () => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("getdistlist");
            let response = yield axios.get(url, config);
            return response;
        });
        const getdistributionlistsSMS = () => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("getdistlist") + `?channel=sms`;
            let response = yield axios.get(url, config);
            return response;
        });
        const getdistributionlistsEmail = () => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            //var url =IP +`/role_mgmt/accounts/${userDetails?.groups[0]}/getentroles?pgsize=${size}&pgindex=${index}`;
            var url = IP + APIMap("getdistlistEmail") + `?channel=email`;
            // var url = "http://localhost:6009/" + APIMap("getdistlistEmail");
            let response = yield axios.get(url, config);
            ////console.log("authcontext", response);
            return response;
        });
        const deletedistibutionlist = (param) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            //var url = "http://43.204.246.49:8081/createcontact"
            var url = IP + APIMap("deletedistlist");
            // var url = "http://localhost:6009/" + APIMap("deletedistlistEmail");
            url = url.replace("{id}", param.queryKey[1]);
            ////console.log("deletecontactgrpurl", url, param);
            let response = yield axios.delete(url, config);
            return response;
        });
        const deletedistibutionlistEmail = (param) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            //var url = "http://43.204.246.49:8081/createcontact"
            var url = IP + APIMap("deletedistlist");
            // var url = "http://localhost:6009/" + APIMap("deletedistlistEmail");
            url = url.replace("{id}", param.queryKey[1]);
            ////console.log("deletecontactgrpurl", url, param);
            let response = yield axios.delete(url, config);
            return response;
        });
        const editdistributionlist = (obj, distlistdetail, values) => __awaiter(void 0, void 0, void 0, function* () {
            var obj1 = {
                jobId: distlistdetail.jobId ? distlistdetail.jobId : null,
                count: (obj === null || obj === void 0 ? void 0 : obj.totalUnique) ? obj.totalUnique : null,
                desc: values.description,
            };
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            //var url = "http://43.204.246.49:8081/createcontact"
            var url = IP + APIMap("editdistlist");
            url = url.replace("{id}", distlistdetail.listId);
            ////console.log("updateurl", url);
            let response = yield axios.put(url, obj1, config);
            return response;
            // return await response;
        });
        const editdistributionlistEmail = (obj, distlistdetail, values) => __awaiter(void 0, void 0, void 0, function* () {
            var obj1 = {
                jobId: distlistdetail.jobId ? distlistdetail.jobId : null,
                count: (obj === null || obj === void 0 ? void 0 : obj.totalUnique) ? obj.totalUnique : null,
                desc: values.description,
            };
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            //var url = "http://43.204.246.49:8081/createcontact"
            var url = IP + APIMap("editdistlistEmail");
            url = url.replace("{id}", distlistdetail.listId);
            ////console.log("updateurl", url);
            let response = yield axios.put(url, obj1, config);
            return response;
            // return await response;
        });
        const createdistlist = (jobId, filesummary, values) => __awaiter(void 0, void 0, void 0, function* () {
            console.log("values", values);
            console.log("filesummary", filesummary);
            var obj1 = {
                name: values.name,
                count: filesummary.totalUnique,
                jobId: jobId,
                dlSummary: true,
                status: "A",
                desc: values.description,
                channel: filesummary.channel,
            };
            ////console.log("in authcontext createdlist", obj1);
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            //var url = "http://43.204.246.49:8081/createcontact"
            var url = IP + APIMap("createdistlist");
            let response = yield axios.post(url, obj1, config);
            return response;
        });
        const createdistlistEmail = (jobId, filesummary, values) => __awaiter(void 0, void 0, void 0, function* () {
            var obj1 = {
                name: values.name,
                count: filesummary.totalUnique,
                jobId: jobId,
                dlSummary: true,
                status: "A",
                desc: values.description,
            };
            ////console.log("in authcontext createdlist", obj1);
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            //var url = "http://43.204.246.49:8081/createcontact"
            var url = IP + APIMap("createdistlistEmail");
            // var url = "http://localhost:6009/" + APIMap("createdistlistEmail");
            let response = yield axios.post(url, obj1, config);
            return response;
        });
        //Role Manangement
        const getTemplates = () => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("getResourcesTemplates");
            let response = yield axios.get(url, config);
            return response;
        });
        const deleteRoleByName = (param) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("deleteRoleById");
            url = url.replace("{roleId}", param.queryKey[1]);
            let response = yield axios.delete(url, config);
            return response;
        });
        const getResourcesByTemplate = (param) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("getResourcesByTemplate");
            url = url.replace("{templateName}", param.queryKey[1]);
            let response = yield axios.get(url, config);
            return response;
        });
        const addRole = (param) => __awaiter(void 0, void 0, void 0, function* () {
            let obj = JSON.parse(JSON.stringify(param));
            let arr = obj.grants.filter((el) => el.check === true);
            arr.forEach((el) => {
                delete el.check;
            });
            obj.grants = arr;
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("addRole");
            let response = yield axios.post(url, obj, config);
            return response;
        });
        const updateRole = (param) => __awaiter(void 0, void 0, void 0, function* () {
            let obj = JSON.parse(JSON.stringify(param.obj));
            delete obj.template;
            delete obj.roleName;
            let arr = obj.grants.filter((el) => el.check === true);
            arr.forEach((el) => {
                delete el.check;
                if (Object.keys(el).includes("resourcedisName")) {
                    delete el.resourcedisName;
                }
            });
            obj.grants = arr;
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("updateRoleById");
            url = url.replace("{roleId}", param.editRoleData);
            let response = yield axios.put(url, obj, config);
            return response;
        });
        const rolePaginationApi = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey, pageParam = 1 }) {
            const config = {
                headers: {
                    Authorization: "Bearer " + queryKey[1],
                },
            };
            const startDate = queryKey[2] && queryKey[3] ? `&fromdate=${queryKey[2]}` : "";
            const endDate = queryKey[2] && queryKey[3] ? `&todate=${queryKey[3]}` : "";
            const filterType = startDate && endDate ? "&filtertype=custom" : "";
            const search = queryKey[4] ? `&name=${queryKey[4]}` : "";
            var url = IP + APIMap("getRoles");
            url =
                url +
                    `?pgsize=${tableDetails.pageSize}&pgindex=${pageParam}${startDate}${endDate}${filterType}${search}`;
            let response = yield axios.get(url, config);
            return { response, nextPage: pageParam + 1 };
        });
        const getRoleById = (param) => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("getRoleById");
            url = url.replace("{roleId}", param.queryKey[1]);
            let response = yield axios.get(url, config);
            return response;
        });
        const roleForExport = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
            const config = {
                headers: {
                    Authorization: "Bearer " + queryKey[1],
                },
            };
            const startDate = queryKey[2] ? `&fromdate=${queryKey[2]}` : "";
            const endDate = queryKey[3] ? `&todate=${queryKey[3]}` : "";
            const filterType = startDate && endDate ? "&filtertype=custom" : "";
            const search = queryKey[4] ? `&name=${queryKey[4]}` : "";
            var url = IP + APIMap("getRoles");
            url =
                url +
                    `?pgsize=${queryKey[0].includes("EXPORT") ? "1000000" : tableDetails.pageSize}&pgindex=1${startDate}${endDate}${filterType}${search}`;
            let response = yield axios.get(url, config);
            return response;
        });
        const roleSearchApi = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey, pageParam = 1 }) {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("getRoles");
            url =
                url +
                    `?name=${queryKey[1]}&pgsize=${tableDetails.pageSize}&pgindex=${pageParam}`;
            let response = yield axios.get(url, config);
            return { response, nextPage: pageParam + 1 };
        });
        const getRoleByGroup = () => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("getRoles");
            let response = yield axios.get(url, config);
            return response;
        });
        const getRoleResource = () => __awaiter(void 0, void 0, void 0, function* () {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = IP + APIMap("getRoleResource");
            let response = yield axios.get(url, config);
            setResourceData(response.data);
            return response;
        });
        const getDateFilter = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey, pageParam = 1 }) {
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                },
            };
            var url = "";
            if (queryKey[3] !== "custom") {
                url = IP + APIMap("getRoles");
                url =
                    url +
                        `?filtertype=${queryKey[3]}&pgsize=${tableDetails.pageSize}&pgindex=${pageParam}`;
            }
            else {
                url = IP + APIMap("getRoles");
                url =
                    url +
                        `?filtertype=${queryKey[3]}&fromdate=${queryKey[1]}&todate=${queryKey[2]}&pgsize=${tableDetails.pageSize}&pgindex=${pageParam}`;
            }
            let response = yield axios.get(url, config);
            return {
                response,
                nextPage: pageParam + 1,
            };
        });
        const userStatus = (email) => __awaiter(void 0, void 0, void 0, function* () {
            var url = IP + APIMap("verifyUserStatus");
            var obj = { user: email };
            let response = yield axios.post(url, obj);
            return response;
        });
        const globalConfigMap = Array.isArray(globalConfig)
            ? new ConfigMap(globalConfig.map(({ key, value }) => [key, value]))
            : new ConfigMap();
        // @todo: remove msisdn option, as it can be duplicate for many countries
        const countryMsiObj = allCountries === null || allCountries === void 0 ? void 0 : allCountries.reduce((acc, curr) => {
            var _a;
            acc[curr.calling_code.replace("+", "")] = Object.assign(Object.assign({}, curr), { name: acc[curr.calling_code.replace("+", "")]
                    ? `${(_a = acc[curr.calling_code.replace("+", "")]) === null || _a === void 0 ? void 0 : _a.name}, ${curr.c_name}`
                    : `(${curr.calling_code}) ${curr.c_name}` });
            return acc;
        }, {});
        const countryOptions = ((_a = Object.keys(countryMsiObj)) === null || _a === void 0 ? void 0 : _a.map((ele) => {
            var _a;
            return {
                label: (_a = countryMsiObj[ele]) === null || _a === void 0 ? void 0 : _a.name,
                value: ele,
            };
        })) || [];
        const OnBoardingApis = {
            signup,
            EmailNotification,
            setPassword,
            forgotPassword,
            getScreenElement,
            getPolicy,
            getTerms,
            setMobileNumber,
            verifyOtp,
            setLoader,
            resetPassword,
            loginCaptcha,
            login,
        };
        const loggedInRole = loggedInRoleMap[userRole] || "NA";
        const isUserRelated = (_b = userRelatedMap[userRole]) !== null && _b !== void 0 ? _b : false;
        const isPARelated = (_c = paRelatedMap[userRole]) !== null && _c !== void 0 ? _c : false;
        return {
            user,
            isAppTimeout, // for timeout dialog before abrupt logout
            userEmail,
            email,
            Time,
            setUser,
            signup,
            setPassword,
            otp,
            login,
            logout,
            closeSesionExpireModal,
            deletefile,
            addEmailTemplate,
            forgotPassword,
            OnBoardingApis,
            resetPassword,
            verifyEmail,
            getPolicy,
            EmailNotification,
            getTerms,
            getScreenElement,
            getResourcesByTemplate,
            Lang,
            BackGroundImage,
            Logo,
            Copyright,
            cpassLogo,
            verifyOtp,
            handleClose,
            getsummary,
            setLoader,
            getRoleById,
            smsTemplates,
            emailTemplates,
            addSmsTemplate,
            getSmsTemplates,
            getEmailTemplates,
            deleteSmsTemplate,
            addEmailTemplate,
            getEmailTemplates,
            deleteSmsTemplate,
            deleteEmailTemplate,
            getTemplateById,
            getRoleByGroup,
            smsTemplateDetails,
            setSmsTemplateDetails,
            EmailTemplateDetails,
            setEmailTemplateDetails,
            setContactDetails,
            filesummary,
            setfilesummary,
            userStatus,
            ContactDetails,
            ContactGroupDetails,
            distributionListDetails,
            setdistributionListDetails,
            setContactGroupDetails,
            singleUserDetails,
            setSingleUserDetails,
            getRoleResource,
            roleSearchApi,
            roleForExport,
            updateRole,
            editSmsTemplate,
            editEmailTemplate,
            editContactList,
            changePassword,
            updateUser,
            deleteRoleByName,
            deleteContactList,
            deletecontactgrp,
            rolePaginationApi,
            editRoleData,
            userData,
            setResourceData,
            getTemplates,
            state,
            getUser,
            addRole,
            resourceData,
            getDateFilter,
            setEditRoleData,
            setAccountsEditData,
            accountsEditData,
            setPackagesEditData,
            packagesEditData,
            setRateSheetEditData,
            rateSheetEditData,
            userDetails,
            addcontact,
            addbulkcontact,
            FileUpload,
            RateSheetFileUpload,
            DLFileUpload,
            DLFileUploadEmail,
            editDLFileUpload,
            editEmailDLFileUpload,
            addcontactgrp,
            ContactList,
            ContactListForExport,
            contactSearchApi,
            Listcontactgrp,
            editcontactgrp,
            deletedistibutionlist,
            deletedistibutionlistEmail,
            createdistlist,
            createdistlistEmail,
            getdistributionlists,
            getdistributionlistsSMS,
            getdistributionlistsEmail,
            editdistributionlist,
            editdistributionlistEmail,
            setTemplates,
            roleTemplates,
            showSessionExpiredModal,
            setShowSessionExpiredModal,
            packages,
            setPackages,
            rateSheets,
            setRateSheets,
            rateSheetDetails,
            setRateSheetDetails,
            userScope,
            userRole,
            loggedInRole, // EA, PA, EU, NA
            isUserRelated,
            isPARelated,
            userGroups,
            selWaTemplateData,
            setSelWaTemplateData,
            enableVoice,
            setEnableVoice,
            setProviderTab,
            setRoutingTab,
            routingTab,
            providerTab,
            numberData,
            setNumberData,
            vrDetails,
            setVrDetails,
            allCountries,
            getAllCountries,
            collapsed,
            setCollapsed,
            addEmailTemplate,
            editRichMediaEmailTemplate,
            getGlobalConfig,
            globalConfig,
            globalConfigMap,
            countryOptions,
            countryMsiObj,
            currencyCode,
            currencySymbol,
            allowedChannels,
            audio,
            setAudio,
            tab,
            setTab,
            peIdDetails,
            setPeIdDetails,
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        token,
        user,
        state,
        userEmail,
        accountsEditData,
        packagesEditData,
        rateSheetEditData,
        userData,
        editRoleData,
        smsTemplateDetails,
        EmailTemplateDetails,
        ContactDetails,
        ContactGroupDetails,
        distributionListDetails,
        singleUserDetails,
        filesummary,
        resourceData,
        userDetails,
        smsTemplates,
        emailTemplates,
        email,
        IP,
        roleTemplates,
        otp,
        showSessionExpiredModal,
        packages,
        rateSheets,
        rateSheetDetails,
        userScope,
        userRole,
        userGroups,
        selWaTemplateData,
        setSelWaTemplateData,
        enableVoice,
        providerTab,
        routingTab,
        numberData,
        vrDetails,
        allCountries,
        collapsed,
        globalConfig,
        audio,
        tab,
        peIdDetails,
    ]);
    // if (!isLoaded) {
    //   return <ThemedSuspense />;
    // }
    return _jsx(AuthContext.Provider, { value: value, children: children });
};
/**
 * @typedef {Object} userDetails
 * @property {string} name
 * @property {string} email
 * @property {boolean} email_verified
 * @property {string} token
 */
/**
 * @typedef {Object} AuthContextValue
 * @property {ConfigMap} globalConfigMap
 * @property {userDetails} userDetails
 * @property {boolean} isAuthenticated
 */
/**
 * @returns {AuthContextValue}
 */
export const useAuthContext = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuthContext must be used within an AuthProvider");
    }
    return context;
};
